import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../../query/types';

const backerConsumerBackerActivityKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'activity'] as const;
  return createQueryKey({
    all: [...key] as const,
    detail: [...key, 'detail'] as const,
  });
};

export { backerConsumerBackerActivityKeys };
